import React from 'react';
// own
import AttachmentsList, { AttachmentComponent } from './components/AttachmentsList';
import { AttachmentsStateProvider } from './provider/AttachmentsStateProvider';
import AttachmentPopup from './components/AttachmentPopup';

export interface Attachment {
  name: string;
  url: string;
  download_url?: string;
}
interface Props<T extends Attachment> {
  attachments: T[];
  maxAttachmentCount?: number;
  AttachmentDetails?: ({ attachment }: { attachment: T }) => JSX.Element;
  AttachmentComponent?: AttachmentComponent<T>;
}

const AttachmentsViewer = <T extends Attachment, >({
  attachments,
  maxAttachmentCount,
  AttachmentDetails,
  AttachmentComponent
}: Props<T>) => {

  if (!attachments.length) return null;

  return (
    <AttachmentsStateProvider attachments={attachments}>
      <AttachmentsList
        maxAttachmentCount={maxAttachmentCount}
        AttachmentComponent={AttachmentComponent}
      />
      <AttachmentPopup AttachmentDetails={AttachmentDetails} />
    </AttachmentsStateProvider>
  );
};

export default AttachmentsViewer;